module.exports = __webpack_public_path__ + "img/contact.c3943871.jpg";